<template>
  <div class="msg-button">
      <button>我是点击按钮</button>
  </div>
</template>

<script>
export default {
    name:'msg-button'

}
</script>
<style lang="scss" scoped>

</style>